import { addMessage, clearMessages } from '../../store/ancillary/actions';

export const dispatchImpersonationMessage = (dispatch, identity) => {
	dispatch(clearMessages());
	dispatch(
		addMessage({
			Key: 2,
			Value: `Submission while impersonating another identity is not permitted.  You are logged in as ${identity.userProfile.Name.replace(
				',',
				', '
			)} and are currently impersonating ${identity.impersonationProfile.Name.replace(
				',',
				', '
			)}.`,
		})
	);
};
